<template>
  <div class="w-full bg-white height-100">
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Manage your campaign credits
          </h2>
        </div>
      </div>
    </div>
    <div class="px-6 py-8 bg-white menucontrol-scroll fixed-top">
      <CalendarDate @setEvents="handleEvents" :indice="indice" />

      <div class="flex gap-12 mt-12">
        <div class="w-2/5">
          <CalendarCampaignDetail :events="events" @selectEvent="handleEvent" />
        </div>
        <div class="w-3/5">
          <Recommendations :event="event" :events="events" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CalendarCampaignDetail from "./components/CalendarCampaignDetail";
import Recommendations from "./components/Recommendations";
import CalendarDate from "./components/CalendarDate";
export default {
  components: {
    CalendarDate,
    Recommendations,
    CalendarCampaignDetail,
  },
  data() {
    return {
      events: [],
      event: "",
      Eventindic: {},
      month: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      day: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
    };
  },

  methods: {
    indice(day) {
      return this.Eventindic[
        `${this.month[new Date(day).getMonth()]}-${new Date(
          day
        ).getDate()}-${new Date(day).getFullYear()}`
      ];
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },

    handleEvents(data) {
      this.events = data;
    },
    handleEvent(data) {
      this.event = !!data ? data : "";
    },
    async getAllEvents() {
      const { data } = await this.$store.dispatch("projectFile/getEvents", {
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
      });
      const events = data.data.map((x, index) => {
        return {
          ...x,
        };
      });
      events.map((item, index) => {
        let date = new Date(item.eventDate);
        const month = this.month[new Date(date).getMonth()];
        const day = new Date(date).getDate();
        const year = date.getFullYear();
        const dateString = `${month}-${day}-${year}`;
        if (!(dateString in this.Eventindic)) {
          this.Eventindic[dateString] = 0;
        }
        this.Eventindic[dateString] += 1;
      });
      console.log(this.Eventindic);
    },
  },

  async mounted() {
    await this.getAllEvents();
  },
};
</script>
